export var ServiceLogType;
(function (ServiceLogType) {
    ServiceLogType["SendEmail"] = "sendEmail";
    ServiceLogType["SendSms"] = "sendSms";
})(ServiceLogType || (ServiceLogType = {}));
